import"./ProductAvailability.css.ts.vanilla.css";var a="_1wz94md0",r="_1wz94md1";export{a as availabilityBase,r as backordered};
